import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { parseISO, format } from "date-fns";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import PayslipModal from "../components/MobilePayslipModal";
import PdfContainer from "../components/PdfContainer";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); // window.matchMedia("(pointer: coarse)").matches;

function GetUrlParamsForPayslipRequest(urlSearchParams = window.location.search) {

  const searchParams = urlSearchParams;
  const urlParams = new URLSearchParams(searchParams);
  let missingUrlParams = [];
  const urlParamsData = {
    'VERSION':'', 
    'PMTREFNB':'', 
    'RCVID':'',
    'TIMESTMP':'',
    'KEYVERS':'',
    'ALG':'',
    'LANGCODE':'',
    'SESSIONID':'',
    'STATUS':'',
    'SENDID':'',
    'PMTORIG':'',
    'USERMAC':'',
    'MAC':''
  };
  for (let param in urlParamsData) {
    const urlParamVal = urlParams.get(param)
    if (urlParamVal === null || urlParamVal === "null" || urlParamVal === "") {
      missingUrlParams.push(param)
    } else {
      urlParamsData[param] = urlParamVal
    }
  }
  const payslipsFetchParams = new URLSearchParams(urlParamsData);
  return {
    urlParams:payslipsFetchParams.toString(), 
    missingParams:missingUrlParams
  }
}

function PayslipPage({modalOpen}){
  const {t} = useTranslation();
  const urlParams = window.location.search;
  const isDark = (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);
  const [, setSearchParams] = useSearchParams();
  const [urlStateData, setUrlParams] = useState('');
  const [selectedSlip, setSelectedSlip] = useState(null);
  const [slipsDisplayed, setSlipsDisplayed] = useState(6);
  const [orderBy, setOrderBy] = useState('desc'); // asc or desc
  const [orderColumn, setColumnToOrderBy] = useState('payment_date'); // defaultOrderColumn
  const [userSearch, setUserSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [paySlips, setPaySlips] = useState([]); // Initialize as []. If null, gives wrong display

  useEffect(() =>{
    let search = '';
    const paramsData = GetUrlParamsForPayslipRequest(urlParams);
    setUrlParams(paramsData.urlParams);
    // Search only lenght >= 3 queries
    if(searchQuery.length >= 3){ search = `&search=${encodeURIComponent(searchQuery)}`; }

    fetch(`/netsalary_payment_data/test_payment_url_link/?${urlStateData}&limit=${slipsDisplayed}&order_column=${orderColumn}&order=${orderBy}${search}`)
      .then(res => res.json())
      .then(data => setPaySlips(data.payments ?? [])); // Default to empty list if no data
  },[slipsDisplayed, searchQuery, orderBy, urlStateData]);

  useEffect(() => {
    setSlipsDisplayed(6);
    setSelectedSlip(null);
  },[orderBy]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchQuery(userSearch);
    },500);

    return () => clearTimeout(handler);
  },[userSearch]);

  const handelSlipClick = (slip) =>{
    if(selectedSlip?.id === slip.id){
      setSelectedSlip(null);
    } else{
      setSelectedSlip(slip);
      if(window.innerWidth < 1200 && !modalOpen){
        const params = new URLSearchParams(window.location.search);
        params.set("modal", "mobilePDF");
        setSearchParams(params);
      }
    }
  };

  // For closing the mobile PDF modal with the phone's systems own back button
  useEffect(() => {
    if(modalOpen){
      const handlePop = () => {
        const params = new URLSearchParams(window.location.search);
        if(params.get("modal") === "mobilePDF"){
          params.delete("modal");
          setSelectedSlip(null);
        }
      };
      window.addEventListener("popstate", handlePop);
      return () => window.removeEventListener("popstate", handlePop);
    }
  },[modalOpen]);

  const printPayslip = () => {

    // THIS if always string:
    //const win = window.open(selectedSlip.file_path, "_blank");

    // OR if can be Blob:
    const url = typeof selectedSlip.file_path === "string"
      ? selectedSlip.file_path
      : URL.createObjectURL(selectedSlip.file_path);
    const win = window.open(url, "_blank");

    // Leave out if we want to direct user to print on mobile/tablet
    if(!isMobile){
      setTimeout(() => win?.print(), 550);
    }
  };

  // Copilotilta. Toimii, mut en tiiä pitäskö oikeesti
  const downloadPayslip = async() =>{
    try{
      const url = selectedSlip.file_path; /*  `/api${selectedSlip.file_path}`  */
      if(!url) return alert(t("errorMessages.noFileFound"));

      // derive filename
      const filename = selectedSlip.file_name || url.split('/').pop() || 'payslip_1page.pdf';
      const res = await fetch(url, { credentials: 'include' }); // include creds if same-site auth required
      if(!res.ok) throw new Error('Network response was not ok');

      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(blobUrl);

    } catch(err){
      console.error(err);
      alert(t("errorMessages.downloadFailed"));
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col col-xl-auto px-3 px-sm-1 py-2 ps-xl-3 pt-xl-3 pe-xl-3 mx-2 mx-sm-5 mt-3 mb-5 m-xl-0 d-flex flex-column listContainer">
            {paySlips?.length < 1 ? (<p className="m-0 py-3 pt-xl-1 text-center text-xl-start" style={{whiteSpace:"pre-line"}}>{t("errorMessages.noDataSide")}</p>) : (
              <>
                <div className="row mb-3 px-0 px-md-3 px-xl-0 px-xxl-3 ms-md-3 ms-xl-0 d-flex flex-row align-items-center justify-content-center justify-content-md-between justify-content-xl-center justify-content-xxl-between">
                  <div className="col-12 p-0 mb-2 mb-xl-0 d-xl-none"><h1 className="mt-1 mb-0 ms-2 ms-sm-4 ms-md-0" style={{fontSize:'1.35rem'}}>{t("payslipList.payslips")}:</h1></div>
                  <div className="col-12 col-md col-xl-12 col-xxl px-0 pe-md-2 pe-xl-0 pe-xxl-2 d-flex align-items-center justify-content-center justify-content-md-between justify-content-xl-center justify-content-xxl-between">
                    <input type="text" id="search-field" name={t('payslipList.searchField')} placeholder={t("payslipList.search")} className="searchField mx-2 mx-sm-4 mx-md-0 mx-xl-3 m-xxl-0"
                      value={userSearch} onChange={(e) => setUserSearch(e.target.value)} />
                  </div>
                  <button onClick={() => orderBy === 'asc' ? setOrderBy('desc') : setOrderBy('asc')} data-message={orderBy === 'asc' ? t('payslipList.orderAsc') : t('payslipList.orderDesc')}
                    className="col-12 col-md-auto col-xl-12 col-xxl-auto gap-2 p-0 px-md-3 px-xl-0 px-xxl-3 m-0 mt-2 mt-md-0 mt-xl-2 mt-xxl-0 d-flex flex-row align-items-center justify-content-center justify-content-md-end justify-content-xl-center justify-content-xxl-end sortButtonContainer">
                    <div aria-hidden="true" className={`sortBubble ${orderBy === 'asc' ? 'active' : ''}`}><i aria-hidden="true" className="bi bi-arrow-up"></i></div>
                    <div aria-hidden="true" className={`sortBubble ${orderBy === 'desc' ? 'active' : ''}`}><i aria-hidden="true" className="bi bi-arrow-down"></i></div>
                    <p className="m-0 textCenter" style={{color:'var(--specialText)'}}>{t("payslipList.date")}</p>
                  </button>
                </div>
                <div className="row">
                  <div className="col d-flex flex-column align-items-center paySlipList px-0 me-xl-1 ms-xl-2 px-sm-1 ps-xl-2 pe-xl-3 py-xl-1" tabIndex={-1} >
                    {paySlips?.length > 0 && paySlips.slice(0, slipsDisplayed).map((slip) => (
                      <div className={`paySlipBubble ${selectedSlip?.id === slip.id ? "active" : ""}`} key={slip.id} tabIndex={0}
                        role="button" aria-label={`${t("payslipList.openSlip")}: ${slip.organization_name} - ${t("payslipList.date")} ${format(parseISO(slip.payment_date), "d.M.yyyy")}`}
                        onKeyDown={(e) => { if(e.key === "Enter"){ handelSlipClick(slip); } if(e.key === " "){ e.preventDefault(); }}}
                        onKeyUp={(e) => { if(e.key === " "){ handelSlipClick(slip); }}} onClick={() => handelSlipClick(slip)}>
                        <div className="row align-items-center">
                          <div className="col-4 col-md-2 col-xl-3 col-xxl-3 px-2 pe-sm-0 ps-sm-3 ms-xl-2 me-md-4 me-lg-1 me-xl-2 ps-xxl-3 d-flex align-items-center justify-content-xl-end"><p className={`m-0 dateText ${isDark ? 'fw-bold' : ''}`}>{format(parseISO(slip.payment_date), "d.M.yyyy")}</p></div>
                          <div className="col ps-md-4 ps-xl-3 ps-xxl-4 pe-1 pe-sm-2"><p className={`m-0 payerText ${isDark ? 'fw-bold' : ''}`}>{slip.organization_name}</p></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {slipsDisplayed < paySlips?.length && (
                  <button data-message={t('payslipList.showMore')} onClick={() => setSlipsDisplayed((prev) => prev + 6)} className="showMoreBtn align-self-center pb-2">
                    <div className="d-flex align-items-center justify-content-center gap-2 mt-0 mt-xl-2">
                      <i aria-hidden="true" className="bi bi-arrow-clockwise d-flex align-items-center justify-content-center pt-1"></i>
                      <p className="m-0 textCenter">{t("payslipList.showMore")}</p>
                    </div>
                  </button>
                )}
              </>
            )}
          </div>
          <div className="col d-none d-xl-block">
            {paySlips?.length < 1 ? <PdfContainer text="noData" isDark={isDark} /> :
            selectedSlip === null ? <PdfContainer text="unselected" isDark={isDark} /> :
            (selectedSlip &&
              <PdfContainer
                payslip={selectedSlip}
                downloadPayslip={downloadPayslip}
                printPayslip={printPayslip}
                isDark={isDark}
              />
            )}
          </div>
        </div>
      </div>
      {modalOpen &&
        <PayslipModal
          modalOpen={modalOpen}
          payslip={selectedSlip}
          downloadPayslip={downloadPayslip}
          printPayslip={printPayslip}
        />
      }
    </>
  );
}

export default PayslipPage;